import React__default, { useState, useEffect } from 'react';
import cn from 'classnames';
import { FilterBucket } from './FilterBucket/index.js';
import { FilterBoolean } from './FilterBoolean/index.js';
import { FilterPrice } from './FilterPrice/index.js';
import styles from 'ui-components/FilterMenu/FilterMenu.scss';

var DefaultCheckmarkIcon = function DefaultCheckmarkIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M17.607 8.232l-7.071 7.071L7 11.768",
    fill: "none",
    fillRule: "evenodd"
  }));
};
var FilterMenu = function FilterMenu(_ref2) {
  var filterState = _ref2.filterState,
    className = _ref2.className,
    _ref2$CheckmarkIcon = _ref2.CheckmarkIcon,
    CheckmarkIcon = _ref2$CheckmarkIcon === void 0 ? DefaultCheckmarkIcon : _ref2$CheckmarkIcon,
    ChevronIcon = _ref2.ChevronIcon,
    closed = _ref2.closed,
    nonLinearSlider = _ref2.nonLinearSlider,
    exponentiation = _ref2.exponentiation;
  var _useState = useState(""),
    openFilter = _useState[0],
    setOpenFilter = _useState[1];
  var sameRange = filterState.price.min === filterState.price.max;
  var autoFilterMinPointsActive = filterState.autoFilterMinPointsActive !== undefined && filterState.autoFilterMinPointsActive !== null && filterState.autoFilterMinPointsActive === true;
  useEffect(function () {
    if (closed === true) {
      setOpenFilter("");
    }
  }, [closed]);
  var _setOpenFilter = function _setOpenFilter(value) {
    if (filterState.loading) {
      return;
    }
    setOpenFilter(value);
  };
  if (!filterState.visible) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, className)
  }, filterState.filters.booleans.map(function (filter) {
    return /*#__PURE__*/React__default.createElement(FilterBoolean, {
      key: filter.code,
      CheckmarkIcon: CheckmarkIcon,
      setOpenFilter: _setOpenFilter,
      openFilter: openFilter,
      filter: filter,
      activeFilters: filterState.active.filters,
      withinBalanceFilter: autoFilterMinPointsActive && filter.code === "within_balance",
      onValueClick: filterState.toggleFilter
    });
  }), filterState.filters.buckets.map(function (filter) {
    return /*#__PURE__*/React__default.createElement(FilterBucket, {
      key: filter.code,
      CheckmarkIcon: CheckmarkIcon,
      ChevronIcon: ChevronIcon,
      setOpenFilter: _setOpenFilter,
      openFilter: openFilter,
      filter: filter,
      activeFilters: filterState.active.filters,
      onValueClick: filterState.toggleFilter
    });
  }), filterState.filters.prices.length > 0 && !sameRange && /*#__PURE__*/React__default.createElement(FilterPrice, {
    ChevronIcon: ChevronIcon,
    nonLinearSlider: nonLinearSlider,
    exponentiation: exponentiation,
    label: filterState.filters.prices[0].label,
    loading: filterState.loading,
    priceRange: filterState.price.range,
    setPriceRange: filterState.price.setRange,
    minPrice: filterState.price.min,
    maxPrice: filterState.price.max,
    openFilter: openFilter,
    setOpenFilter: _setOpenFilter,
    usePoints: Boolean(filterState.usePoints),
    balance: filterState.balance
  }));
};

export { FilterMenu };
//# sourceMappingURL=index.js.map
